import * as types from '../../lib/actionTypes.es6';

export function getRiskConfigsRequest(partner) {
  return { type: types.GET_RISK_CONFIGS_REQUEST, payload: partner };
}
export function getRiskConfigsSuccess(configs) {
  return { type: types.GET_RISK_CONFIGS_SUCCESS, payload: configs };
}
export function getRiskConfigsFail(error) {
  return { type: types.GET_RISK_CONFIGS_FAIL, payload: error };
}

export function getRiskConfigRawRequest(partner) {
  return { type: types.GET_RISK_CONFIG_RAW_REQUEST, payload: { partner } };
}
export function getRiskConfigRawSuccess(raw) {
  return { type: types.GET_RISK_CONFIG_RAW_SUCCESS, payload: raw };
}
export function getRiskConfigRawFail(error) {
  return { type: types.GET_RISK_CONFIG_RAW_FAIL, payload: error };
}
export function getRiskConfigRawReset() {
  return { type: types.GET_RISK_CONFIG_RAW_RESET };
}

export function publishRiskConfigRequest(partner, rawYaml) {
  return { type: types.PUBLISH_RISK_CONFIG_REQUEST, payload: { partner, rawYaml } };
}
export function publishRiskConfigSuccess(result) {
  return { type: types.PUBLISH_RISK_CONFIG_SUCCESS, payload: result };
}
export function publishRiskConfigFail(error) {
  return { type: types.PUBLISH_RISK_CONFIG_FAIL, payload: error };
}
export function publishRiskConfigReset() {
  return { type: types.PUBLISH_RISK_CONFIG_RESET };
}

export function createRiskConfigRequest(partner, rawYaml) {
  return { type: types.CREATE_RISK_CONFIG_REQUEST, payload: { partner, rawYaml } };
}
export function createRiskConfigSuccess(result) {
  return { type: types.CREATE_RISK_CONFIG_SUCCESS, payload: result };
}
export function createRiskConfigFail(error) {
  return { type: types.CREATE_RISK_CONFIG_FAIL, payload: error };
}
export function createRiskConfigReset() {
  return { type: types.CREATE_RISK_CONFIG_RESET };
}
